import * as React from 'react';
import Snackbar, { SnackbarCloseReason, SnackbarOrigin } from '@mui/material/Snackbar';
import Alert, { AlertColor, AlertProps } from '@mui/material/Alert';
import Slide, { SlideProps } from '@mui/material/Slide';

type TransitionProps = Omit<SlideProps, 'direction'>;

function SlideUp(props: TransitionProps) {
    return <Slide {...props} direction="up" />;
}

type SnackAlertProps = {
    open: boolean;
    onClose?: (event?: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => void;
    text?: string;
    severity?: AlertColor; // "success" | "info" | "warning" | "error"
    variant?: AlertProps['variant']; // "filled" | "outlined" | "standard"
    autoHideDuration?: number;
    anchorOrigin?: SnackbarOrigin;
    size?: 'sm' | 'md' | 'lg';
    elevation?: number;
    TransitionComponent?: React.ComponentType<TransitionProps>;
    action?: React.ReactNode;
    sx?: object;
};

export default function SNACK_ALERT({
    open,
    onClose,
    text = 'Operación realizada',
    severity = 'success',
    variant = 'filled',
    autoHideDuration = 4000,
    anchorOrigin = { vertical: 'bottom', horizontal: 'right' },
    size = 'md',
    elevation = 6,
    TransitionComponent = SlideUp,
    action = null,
    sx = {},
}: SnackAlertProps) {
    const widthMap: Record<NonNullable<SnackAlertProps['size']>, number> = {
        sm: 280,
        md: 360,
        lg: 520,
    };

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
        if (reason === 'clickaway') return;
        onClose?.(event, reason);
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
            anchorOrigin={anchorOrigin}
            TransitionComponent={TransitionComponent}
        >
            <Alert
                onClose={onClose ? handleClose : undefined}
                severity={severity}
                variant={variant}
                elevation={elevation}
                action={action}
                sx={{
                    width: widthMap[size] || '100%',
                    color: '#fff',              // Texto blanco
                    '& .MuiAlert-icon': {
                        color: '#fff',            // Icono blanco
                    },
                    '& .MuiAlert-action button': {
                        color: '#fff',          // Botón de cerrar blanco
                    }
                }}
            >
                <p style={{ color: 'white', textAlign: 'justify', margin: 0 }}>
                    {text}
                </p>
            </Alert>
        </Snackbar>
    );
}
